import type { ProfilePermissions } from "@qendo/permissions";
import type { ProfileRole } from "@qendo/profile";
import type { AgeRange, BloodType, Gender } from "@qendo/types";
import { Goals } from "~/entities/profile/goals";
import Data from "~/util/data";

export class Profile extends Data {
    public constructor(
        public id: string,
        public name: string,
        public avatar: string,
        public phone: string | null = null,
        public notes: string | null = null,
        public postcode: string | null = null,
        public age_range: AgeRange | null = null,
        public gender: Gender | null = null,
        public blood_type: BloodType | null = null,
        public team_role?: ProfileRole | null,
        public permissions?: ProfilePermissions | null,
        public goals: Goals = new Goals(),
        public country: string | null = null,
        public photograph_id: string | null = null,
        public created_at: string | null = null,
    ) {
        super();
    }
}
